import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_COMMENTS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/comments',
        iconClass: 'fas fa-comments',
        name: 'Comments',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.Comments',
        order: 3
      },
    ]);
  };
}
